import API from './services/api'
import { notification } from './services/notification'

export default class ButtonFollow {
  constructor() {
    const buttons = document.querySelectorAll('[data-follow]')

    buttons.forEach((e) => {
      e.addEventListener('click', async () => {
        e.classList.add('is-loading')

        try {
          if (e.dataset.user == null) {
            notification.confirm.require({
              header: 'Adaugă la favorite',
              message:
                'Trebuie să te autentifici pentru a putea adăuga la favorite.',
              rejectProps: {
                label: 'Anulează',
                severity: 'secondary',
                outlined: true,
              },
              acceptProps: {
                label: 'Autentifică-te',
                severity: 'success',
              },
              accept: () => {
                window.location.href =
                  '/accounts/login/?next=' + window.location.pathname
              },
            })
          } else {
            const response = await API.toggleFollow({
              object_id: e.dataset.objectId,
              content_type: e.dataset.contentType,
            })

            e.classList.toggle('is-active', response.status === 'favorited')
            if (response.status === 'favorited') {
              notification.toast.add({
                group: 'favorite-follow',
                severity: 'success',
                summary: 'Adăugat la favorite',
                detail:
                  'Vei primi o notificare pe e-mail atunci când apar noi reprezentații.',
                life: 5000,
              })
            }
          }
        } catch (response) {
        } finally {
          e.classList.remove('is-loading')
        }
      })
    })
  }
}
